// extracted by mini-css-extract-plugin
export default {"list-content":"ListPage_list-content__DBLij","button-area":"ListPage_button-area__L9fjs"};